export default __webpack_public_path__ + "static/media/background-night.ddf47852.svg";